// extracted by mini-css-extract-plugin
module.exports = {"customInput":"phone-login_customInput__qf2pt","emailLogin":"phone-login_emailLogin__CuI90"};